module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan4-3-374d9180fd1d93bc7ee38a0047b67ff4.webp";